export enum PunishmentPeriodEnum {
  TWELVE_HOURS = 'TWELVE_HOURS',
  THREE_DAYS = 'THREE_DAYS',
  SEVEN_DAYS = 'SEVEN_DAYS',
  THIRTY_DAYS = 'THIRTY_DAYS',
  FOREVER = 'FOREVER',
}
